<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Bank Account Particulars</strong>
      </span>
      <span style="float: right">
        <!-- <a [routerLink]="['/bankparticulars/add']"> -->
          <button (click)="add()"  class="btn btn-success pull-right"  [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}" 
          class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <!-- <form (document:click)="appDate.close();cesDate.close();"> -->
            <div class="row">
              <div class="col-md-3">
                <label>Name of Bank 
                </label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="nameOfBank"> &nbsp;&nbsp;&nbsp;
                </div>
                <br>
              </div>
  
  
              <div class="col-md-3">
                <!-- <label>Date of passing resolution to close bank account</label> -->
                <!-- <label>From</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From :&nbsp;
                  <input id="dateOfClose" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfClose" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfClose">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                
                </div>
              </div>
  
  
              <div class="col-md-3">
                <!-- <label>Date of passing resolution to open bank account</label> -->
                <!-- <label>To</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                
                   To :&nbsp;
                  <input id="dateOfOpen" class="form-control" [minDate]="futureToDateTo"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfOpen" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfOpen">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
  
  
  
              <div class="col-sm-2 col-lg-2 col-md-2">
                <br>
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector"
              class="table table-hover compact cell-border nowrap stripe" id="directormasterbankTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Name of the Bank</th>
                    <th>Name of Authorised <br> Signatory</th>
                    <th>Name of the Branch</th>
                    <th>Address </th>
                    <th>Contact No. </th>
                    <th>Type of Account</th>
                    <th>Bank Account No.</th>
                    <th>IFSC Code</th>
                    <th>Locker no.</th>
                    <th>Term Loan </th>
                    <th>Sum Borrowed</th>
                    <th>Date of passing <br>resolution to <br>close bank account</th>
                    <th style="display: none;">Date of passing resolution to close bank account</th>
                    <th>Date of passing <br>resolution to <br>open bank account</th>
                    <th style="display: none;">Date of passing resolution to open bank account</th>
                    <!-- <th>Status</th> -->
                    <th class="actionclass">Action
                      <!-- <span [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}">Action</span> -->
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor= "let director of registerDirectorList">
                    <td>{{director.nameofthedocument}}</td>
                    <td>{{director.nameofsignatoryn}}</td>
                    <td>{{director.nameofthebranch}}</td>
                    <td>{{director.addressofthebank}}</td>
                    <td>{{director.contactofthebank}}</td>
                    <td>{{director.typeofaccount}}</td>
                    <td>{{director.bankaccountnumber}}</td>
                    <td>{{director.ifsc}}</td>
                    <td>{{director.locker ? director.locker.lockernumber : ''}}</td>
                    <td>
                      <ng-container *ngIf="director.loan">
                        <span *ngIf="director.loan.typeofloan=='CC'">CC / OD Facility</span>
                        <span *ngIf="director.loan.typeofloan=='Term Loan'">Term Loan (Short term / Long term)</span>
                      </ng-container>
                    </td>
                    <td>{{director.loan ? director.loan.sumborrowed: ''}}</td>
  
  
                    <td>
                      <span *ngIf="director.closure">
                      <span style="display: none">{{director.closure.dateofpassingresolution | date : "yMMdd"}}</span>
                      {{director.closure.dateofpassingresolution | date : "dd-MM-y"}}
                    </span>
                    </td>
                    <td style="display: none;">
                      <span *ngIf="director.closure">
                      {{director.closure.dateofpassingresolution | date : "dd-MM-y"}}
                      </span>
                    </td>
  
  
  
                    <td>
                      <span style="display: none">{{director.dateofpassing | date : "yMMdd"}}</span>
                      {{director.dateofpassing | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none;">
                      {{director.dateofpassing | date : "dd-MM-y"}}
                    </td>
  
  
                    <td style='white-space: nowrap'>
                      <div class="input-group">
                        <button type="button"  [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}"
                         (click)="loadDetailsById(director._id)" class="btn-sm btn btn-warning">
                          <span class="fa fa-pencil"></span>
                        </button>
                        &nbsp;&nbsp;
                        <button type="button"  [appHasPermission]="{'Url': '/register/masterbankparticulars/edit?goveva=true&email=', 'method':'put', 'menu': 'masterbankparticulars'}"
                        class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)">
                          <span class="icmn-bin"></span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete bank account particular details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deletebankdetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>